// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Cota } from "../interfaces/Cota";

export const cadastrarCotaService = async (data: Cota) => {
  const Token = validateToken();

  const apId = data.aptoId;

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota/${apId}`;
    try {
      const response = await axios.post(URL, data, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
